module.exports = __webpack_public_path__ + "img/cc-visa.397a54e4.svg";